import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import onClickOutside from 'react-onclickoutside'
import mousetrap from 'mousetrap'

import classNames from './AlbumPicker.css'
import Icon from '../Icon'
import { AUTO_PLAYLIST_SUFFIX } from '../../constants'

class PlaylistPicker extends Component {
  state = {
    text: '',
    showAutocomplete: false,
    selected: -1
  }
  componentDidMount () {
    this.node = findDOMNode(this)
    mousetrap.bind('up', this.onKeyUp)
    mousetrap.bind('down', this.onKeyDown)
    mousetrap.bind('escape', () => {
      this.clearSearch()
      this.setState({ showAlbumList: false })
      this.refs.search.blur()
    })
  }
  componentDidUpdate (prevProps, prevState) {
    const { selected } = this.state
    if (prevState.selected !== selected) {
      const button = this.node.querySelectorAll('.' + classNames.autoCompleteItem)[selected]
      button && button.focus()
    }
  }
  componentWillUnmount () {
    mousetrap.unbind(['up', 'down', 'escape'])
  }
  onKeyDown = e => {
    e.preventDefault()
    this.setState({ selected: this.state.selected + 1 })
  }
  onKeyUp = e => {
    e.preventDefault()
    if (this.state.selected === 0) {
      this.refs.search.focus()
    }
    this.setState({ selected: Math.max(-1, this.state.selected - 1) })
  }
  handleClickOutside = () => {
    this.setState({
      showAutocomplete: false,
      selected: -1
    })
  }
  onChangeText = e => {
    this.setState({
      text: e.target.value,
      selected: -1
    })
  }
  selectPlaylist = id => {
    const { onChange } = this.props
    onChange(id)
    this.setState({
      text: '',
      selected: -1,
      showAutocomplete: false
    })
  }
  showAutocomplete = () => {
    this.setState({
      showAutocomplete: true
    })
  }
  clearSearch = () => {
    this.setState({
      text: '',
      selected: -1,
      showAutocomplete: false
    })
  }
  searchString = (substring, string) => {
    return string.toLowerCase().indexOf(substring.toLowerCase()) !== -1
  }
  renderPlaylist = ({ id, name, json_data }) => {
    const { getImageSource } = this.props
    const onClick = () => this.selectPlaylist(id)
    let cover = null
    try {
      const albumID = JSON.parse(json_data).albums[0].album
      cover = this.props.albums.filter(a => a.id === albumID)[0].cover
    } catch (e) { }
    return (
      <li key={id}>
        <button onClick={onClick} className={classNames.autoCompleteItem}>
          {getImageSource &&
            <div
              className={classNames.cover}
              style={{ backgroundImage: `url(${this.props.getImageSource(cover)})` }}
            />
          }
          {name}
        </button>
      </li>
    )
  }
  renderAlbum = ({ id, name, cover }) => {
    const { savePlaylist, getImageSource } = this.props
    const onClick = () => {
      const data = { name: name + AUTO_PLAYLIST_SUFFIX }
      const structure = { albums: [ { album: id } ] }
      this.setState({
        showAutocomplete: false
      })
      savePlaylist(data, structure, null, false).then(playlist => {
        this.selectPlaylist(playlist.id)
      })
    }
    return (
      <li key={id}>
        <button onClick={onClick} className={classNames.autoCompleteItem}>
          {getImageSource &&
            <div
              className={classNames.cover}
              style={{ backgroundImage: `url(${this.props.getImageSource(cover)})` }}
            />
          }
          {name}
        </button>
      </li>
    )
  }
  renderAutocomplete = () => {
    const { playlists, albums } = this.props
    const { text } = this.state

    const filteredPlaylists = playlists
      .filter(playlist => this.searchString(text, playlist.name))
      .filter(playlist => playlist.name.indexOf(AUTO_PLAYLIST_SUFFIX) === -1)
      .map(this.renderPlaylist)

    const filteredAlbums = albums
      .filter(album => this.searchString(text, album.name))
      .map(this.renderAlbum)

    return (
      <ul className={classNames.autoComplete}>
        {filteredPlaylists.length !== 0 &&
          <li className={classNames.autoCompleteHeading}>
            Playlists
          </li>
        }
        {filteredPlaylists}
        {filteredAlbums.length !== 0 &&
          <li className={classNames.autoCompleteHeading}>
            Albums <span>(Auto-create playlist)</span>
          </li>
        }
        {filteredAlbums}
      </ul>
    )
  }
  render () {
    const { text, showAutocomplete } = this.state
    return (
      <div className={classNames.wrapper}>
        <input
          type='text'
          value={text}
          onChange={this.onChangeText}
          onClick={this.showAutocomplete}
          className={'mousetrap ' + classNames.input}
          placeholder='Add a playlist or album'
          ref='search'
        />
        {(text !== '' || showAutocomplete) &&
          <button onClick={this.clearSearch} className={classNames.clearButton}>
            <Icon icon='close' />
          </button>
        }
        {showAutocomplete &&
          this.renderAutocomplete()
        }
      </div>
    )
  }
}

export default onClickOutside(PlaylistPicker)



// WEBPACK FOOTER //
// ./src/components/playlist/PlaylistPicker.js